module.exports = __webpack_public_path__ + "img/35.3c1042cf.png";